/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  isLoading: false,
  planType: [],
  rebateProgram: [],
  errorMsgDisputeRecap: [],
  drugSelected: 'Current Disputes',
  qtrSelected: 'All',
  quarterFrom: '',
  quarterTo: '',
  checkedValue: true,
  checkBox: false,
  rebateProgramName: {},
  recapGrid: [],
  allManufacturer: [],
  manufactureWithIds: [],
  manufacturerList: [],
  includeActivity: [],

  displayObj: {
    recapGrid: [],
    manufactureWithIds: [],
    rebateProgramName: {},
    allManufacturer: [],
    drugSelected: 'Current Disputes',
    manufacturerList: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_RECAP:
      return { ...state, performDisputeResolutionObj: action.screenData };
    case actionTypes.SET_LOADING_DISPUTE_RECAP:
      return { ...state, isLoading: action.payload };
    case actionTypes.GET_ERROR_MSG_DISPUTE_RECAP:
      return { ...state, errorMsgDisputeRecap: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_RECAP:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_RECAP:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_RECAP:
      return { ...state, rebateProgramName: action.payload };
    //Manufacturer Grid
    case actionTypes.GET_MANUFACTURERS_LIST_RECAP:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionTypes.SET_DISPLAY_OBJ_RECAP:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_DISPLAY_RECAP_GRID:
      let displayObj = {
        ...state.displayObj,
        recapGrid: action.payload,
      };
      return { ...state, recapGrid: action.payload, displayObj };

    case actionTypes.GET_DRUG_RECAP:
      return { ...state, drugSelected: action.payload };
    case actionTypes.ACTIVITY_TABLE_DATA:
      return { ...state, activitytbldata: action.payload };
    case actionTypes.UPDATE_RECAP_MAILOUT_DT:
      return { ...state, updatedRecapMail: action.payload };
    case actionTypes.GET_CODE_DATA:
      return { ...state, dispute_codes: action.payload };
    case actionTypes.GET_QUARTER_RECAP:
      return { ...state, qtrSelected: action.payload };
    case actionTypes.GET_RECENTLY_CLOSED:
      return { ...state, checkedValue: action.payload };
    case actionTypes.GET_INCLUDE_ACTIVITY:
      return { ...state, checkBox: action.payload };
    case actionTypes.GET_MANUFACTURER_NAME_RECAP:
      return { ...state, allManufacturer: action.allManufacturer };
    case actionTypes.GET_MANUFACTURER_ID_RECAP:
      return { ...state, manufactureWithIds: action.manufactureWithIds };
    case actionTypes.GET_FROM_RECAP:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.GET_TO_RECAP:
      return { ...state, quarterTo: action.payload };
    case actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE_RECAP:
      return { ...state, dramsInvoice: action.payload };
    case actionTypes.GET_INCLUDE_ACTIVITY_DROPDOWN:
      return { ...state, includeActivity: action.payload };
    case actionTypes.SET_REFRESH_DATA_RECAP:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        rebateProgram: [],
        errorMsgDisputeRecap: [],
        drugSelected: 'Current Disputes',
        qtrSelected: 'All',
        quarterFrom: '',
        quarterTo: '',
        checkedValue: true,
        checkBox: false,
        rebateProgramName: {},
        recapGrid: [],
        allManufacturer: [],
        manufactureWithIds: [],
        manufacturerList: [],
      };
    case actionTypes.REFRESH_DATA_RECAP_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
